import logoEncabezadoApi from "../services/api/logo-encabezado";

export const useLogoEncabezado = async () => {
  const logoEncabezadoResponse = logoEncabezadoApi.getLogoEncabezado;
  const result = await logoEncabezadoResponse();
  return result.data.data.attributes.imagen.data.attributes.url;
};
